import React from "react";
import "./index.scss";

export const RitchTextRenderer = ({ html }) => (
  <div
    className="ritch-text-renderer"
    dangerouslySetInnerHTML={{ __html: html }}
  ></div>
);
